import { FormControl, styled } from '@mui/material';
var SFormControl = styled(FormControl, {
    shouldForwardProp: function (prop) { return !['labelPlacement', 'insets'].includes(prop.toString()); },
    name: 'MuiFormControl',
    overridesResolver: function (_a) {
        var labelPlacement = _a.labelPlacement, insets = _a.insets, theme = _a.theme;
        var customOverrides = theme.components.MuiFormControl.customOverrides;
        return [customOverrides["".concat(labelPlacement, "Placement")], insets && customOverrides.insets];
    },
})({});
export default SFormControl;
